import React from 'react';
interface FieldGridProps {
  children: ReactNode;
  columns?: 1 | 2;
}
export function FieldGrid({
  children,
  columns = 2
}: FieldGridProps) {
  return <div className={`grid gap-x-4 gap-y-2.5 ${columns === 2 ? 'md:grid-cols-2' : 'grid-cols-1'}`} data-id="element-109">
      {children}
    </div>;
}